"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatePreviewCard = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const document_template_png_1 = __importDefault(require("../../../../../assets/document_template.png"));
const doshx_controls_web_1 = require("doshx_controls_web");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const main_1 = require("../../../../../reducers/slices/main");
const delete_document_thunk_1 = require("../../../../../reducers/slices/document/thunks/delete/delete_document_thunk");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const template_preview_modal_1 = require("./template_preview_modal");
const TemplatePreviewCard = ({ template, onClick }) => {
    var _a;
    const [mouseIsOver, setMouseIsOver] = (0, react_1.useState)(false);
    const { selectedTemplateID } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const templateDiv = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (templateDiv) {
            const width = templateDiv.current.offsetWidth;
            templateDiv.current.style.minHeight = `${width + width / 4}px`;
            templateDiv.current.style.height = `${width + width / 4}px`;
        }
    }, []);
    const handleSelectedTemplate = () => {
        let _class = "";
        if (selectedTemplateID === template._id) {
            _class = "border-secondary -translate-y-1 scale-110";
        }
        return _class;
    };
    return (react_1.default.createElement("div", { onMouseEnter: () => {
            setMouseIsOver(true);
        }, onMouseLeave: () => {
            setMouseIsOver(false);
        }, ref: templateDiv, className: ` relativetransition ease-in-out delay-150 w-full bg-white shadow-md flex flex-col item-center cursor-pointer border ${handleSelectedTemplate()} relative overflow-hidden hover:border-primary hover:-translate-y-1 hover:scale-110 duration-300` },
        selectedTemplateID === template._id && (react_1.default.createElement("div", { className: " absolute top-1 left-[85%] flex justify-center items-center h-6 w-6 bg-secondary rounded-full" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheck, className: "text-white font-bold" }))),
        react_1.default.createElement("div", { onClick: onClick, className: "w-full" },
            react_1.default.createElement("img", { src: (_a = template === null || template === void 0 ? void 0 : template.image) !== null && _a !== void 0 ? _a : document_template_png_1.default, className: "w-full" })),
        mouseIsOver && (react_1.default.createElement("div", { className: "flex w-full gap-2 absolute bottom-0 p-1" },
            react_1.default.createElement("div", { onClick: (e) => {
                    e.stopPropagation();
                    dispatch((0, main_1.setContentModal)({
                        title: `Preview: ${template.name}`,
                        content: react_1.default.createElement(template_preview_modal_1.TemplatePreviewModal, { template: template }),
                    }));
                }, className: "flex-1 p-1 bg-secondary text-white rounded-md text-center w-full" }, "Preview"),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faTrash, backgroundColor: "bg-white", borderColor: "border-error", iconColor: "text-error", size: "xsmall", onClick: () => {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Confirm!",
                            messages: [`Are you sure you want to delete template '${template.name}'?`],
                            buttons: [
                                {
                                    label: "Cancel",
                                    backgroundColor: "bg-white",
                                    textColor: "text-primary",
                                    borderColor: "border-primary",
                                    onClick: () => {
                                        dispatch((0, main_1.setMessageModal)(null));
                                    },
                                },
                                {
                                    label: "Confirm",
                                    onClick: () => {
                                        dispatch((0, delete_document_thunk_1.delete_document_thunk)({ type: "template", data: { _id: template._id } }));
                                        dispatch((0, main_1.setMessageModal)(null));
                                    },
                                },
                            ],
                        }));
                    } }))))));
};
exports.TemplatePreviewCard = TemplatePreviewCard;
